import { GameObject } from "./GameObject";

export class CameraController {

	cam: Phaser.Cameras.Scene2D.Camera;
	x: number;
	y: number;
	width: number;
	height: number;

	followTarget: GameObject | null;
	targetOffset: Phaser.Math.Vector2 = new Phaser.Math.Vector2();

	constructor(camera: Phaser.Cameras.Scene2D.Camera) {
		this.cam = camera;
		this.x = this.cam.scrollX;
		this.y = this.cam.scrollY;
		this.width = 0;
		this.height = 0;
	}

	startFollow(target: GameObject | null, offsetX = 0, offsetY = 0): void {
		this.targetOffset = new Phaser.Math.Vector2(offsetX, offsetY);
		this.followTarget = target;
	}

	private getTargetPosition(target: GameObject): Phaser.Math.Vector2 {
		return new Phaser.Math.Vector2(target.x - this.cam.width / 2 + this.targetOffset.x, target.y - this.cam.height / 2 + this.targetOffset.y);
	}

	centerOn(target: GameObject): void {
		const targetPos = this.getTargetPosition(target);
		this.setPosition(targetPos.x, targetPos.y);
	}

	setPosition(x: number, y: number): void {
		this.x = x;
		this.y = y;
		this.setCoords();
	}

	setBounds(x: number, y: number, width: number, height: number): void {
		this.cam.setBounds(x, y, width, height);
		this.width = width;
		this.height = height;
	}

	update(dt: number): void {
		if (this.followTarget) {
			const targetPos = this.getTargetPosition(this.followTarget);
			this.x -= (this.x -targetPos.x) * 8 * dt;
			// this.y -= (this.y -targetPos.y) * 8 * dt;
			this.setCoords();
		}
	}

	setCoords(): void {
		this.cam.scrollX = Math.round(this.x);
		this.cam.scrollY = Math.round(this.y);
	}

}